import type { HeroSlide } from "@/types/movie";

export const heroSlides: HeroSlide[] = [
  {
    movieId: "star-echo",
    tagline: "跨越光年的回信，在宇宙尽头等待回音",
    label: "本周焦点",
  },
  {
    movieId: "long-night",
    tagline: "长夜将尽，黎明之前，他必须做出最后的选择",
    label: "热映推荐",
  },
  {
    movieId: "blue-whale",
    tagline: "三年跨越三大洋，跟随蓝鲸见证海洋的呼吸",
    label: "口碑纪录片",
  },
  {
    movieId: "seventh-suspect",
    tagline: "密室之中七个人，只有一个在讲真话",
    label: "年度悬疑",
  },
  {
    movieId: "mountain-sea-scroll",
    tagline: "一卷古画，打开山海异兽共存的奇幻世界",
    label: "国风动画",
  },
];